// extracted by mini-css-extract-plugin
export default {"container":"Ik-z","blurb":"Jk-z","links":"Kk-z"};